import { Routes } from '@angular/router';
import { MentorSignUpComponent } from '../mentor-portal/mentor-sign-up/mentor-sign-up.component';
import { MentorSignUpStepsComponent } from '../mentor-portal/mentor-sign-up/mentor-sign-up-steps/mentor-sign-up-steps.component';
import { PartnerPortalLayoutComponent } from '../partner-portal/partner-portal-layout/partner-portal-layout.component';
import { MentorDashboardComponent } from '../mentor-portal/mentor-dashboard/mentor-dashboard.component';
import { InstituteDetailComponent } from '../student-portal/institute-detail/institute-detail.component';
import { MentorProfileComponent } from '../student-portal/mentor-profile/mentor-profile.component';
import { AccountCentreComponent } from '../student-portal/account-centre/account-centre.component';
import { ScheduledMeetingsComponent } from '../mentor-portal/scheduled-meetings/scheduled-meetings.component';
import { ApplicantProfileComponent } from '../mentor-portal/applicant-profile/applicant-profile.component';
import { ReviewSubmissionComponent } from '../mentor-portal/review-submission/review-submission.component';
import { InstituteSearchComponent } from '../student-portal/institute-search/institute-search.component';
import { PermissionGuard } from '../guards/permission.guard';
import { UserRole } from '../models/enums/UserRole';
import { ChatComponent } from '../student-portal/chat/chat.component';

export const mentorRoutes: Routes = [
  {
    path: 'mentor-signup', component: MentorSignUpComponent
  },
  {
    path: 'mentor-signup-steps', component: MentorSignUpStepsComponent
  },
  {
    path: 'mentor-portal', component: PartnerPortalLayoutComponent,
    data: { portal: 'partner' },
    children: [
      {
        path: '', redirectTo: 'schedule-meetings', pathMatch: 'full'
      },
      {
        path: 'dashboard', component: MentorDashboardComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: ':id/institute',
        component: InstituteDetailComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard],
        pathMatch: 'prefix'
      },
      {
        path: 'mentor-profile/:id',
        component: MentorProfileComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'account-centre',
        component: AccountCentreComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard]

      },
      {
        path: 'schedule-meetings', component: ScheduledMeetingsComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
      },
      {
        path: 'app-applicant-profile/:id', component: ApplicantProfileComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'app-review-submission', component: ReviewSubmissionComponent,
            data: {
              expectedRoles: [UserRole.Mentor],
            },
            canActivate: [PermissionGuard]
          }
        ]
      },
      {
        path: 'institute-search/:id',
        component: InstituteSearchComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard]
      },
      {
        path: 'chat',
        component: ChatComponent,
        data: {
          expectedRoles: [UserRole.Mentor],
        },
        canActivate: [PermissionGuard]
      }
    ]
  }
];

